// extracted by mini-css-extract-plugin
export default {"section":"bzRM6","head":"rkoY1 ZdH1P","description":"uLtuo DS0GQ","title":"vFBoK JgjPU","priceMin":"Cx30P AawBX","arrows":"Axh02","additional":"uUNGV"};